// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1e3Vf","header":"MessagesList_header__3gZsZ","chat":"MessagesList_chat__1ufi_"};